import React from 'react';
import {MenuPanels} from '../../core'

export default function SGMenuPanelsPage() {

    return <div>
        <MenuPanels />
    </div>
}